"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.positions = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = require("prop-types");

var _core = require("@popperjs/core");

var _Tooltip = require("./Tooltip.styles");

var _hooks = require("../../hooks");

/* eslint-disable react/jsx-props-no-spreading */
var Arrow = (0, _base["default"])("div", {
  target: "ekxrxdq1",
  label: "Arrow"
})(_Tooltip.styles.arrow, ";");
var Popup = (0, _base["default"])("div", {
  target: "ekxrxdq0",
  label: "Popup"
})(_Tooltip.styles.base, " &[data-popper-placement='top'],&[data-popper-placement='bottom']{text-align:center;&>", Arrow, "{text-align:left;}}&[data-popper-placement^='top']>", Arrow, "{bottom:-4px;}&[data-popper-placement^='bottom']>", Arrow, "{top:-4px;}&[data-popper-placement^='left']>", Arrow, "{right:-4px;}&[data-popper-placement^='right']>", Arrow, "{left:-4px;}"); // https://popper.js.org/docs/v2/constructors/#options

var positions = ['auto', 'auto-start', 'auto-end', 'top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'right', 'right-start', 'right-end', 'left', 'left-start', 'left-end'];
exports.positions = positions;
var showEvents = ['mouseenter', 'focus'];
var hideEvents = ['mouseleave', 'blur'];
var showAttribute = 'data-show';

var bindEvents = function bindEvents(_ref) {
  var triggerElement = _ref.triggerElement,
      show = _ref.show,
      hide = _ref.hide;
  // Bind mouseenter and focus events
  showEvents.forEach(function (event) {
    triggerElement.addEventListener(event, show);
  }); // Bind mouseleave and blur events

  hideEvents.forEach(function (event) {
    triggerElement.addEventListener(event, hide);
  });
};

var removeEvents = function removeEvents(_ref2) {
  var triggerElement = _ref2.triggerElement,
      show = _ref2.show,
      hide = _ref2.hide;
  // Remove mouseenter and focus events
  showEvents.forEach(function (event) {
    triggerElement.removeEventListener(event, show);
  }); // Remove mouseleave and blur events

  hideEvents.forEach(function (event) {
    triggerElement.removeEventListener(event, hide);
  });
};

var Tooltip = function Tooltip(_ref3) {
  var title = _ref3.title,
      children = _ref3.children,
      position = _ref3.position,
      className = _ref3.className,
      delay = _ref3.delay,
      maxWidth = _ref3.maxWidth,
      offset = _ref3.offset,
      strategy = _ref3.strategy,
      disabled = _ref3.disabled,
      portal = _ref3.portal;

  var _useChildRef = (0, _hooks.useChildRef)(children),
      child = _useChildRef.child,
      triggerRef = _useChildRef.triggerRef;

  var popperRef = (0, _react.useRef)(null);
  var popperInstanceRef = (0, _react.useRef)(null);
  var defaultModifiers = (0, _react.useMemo)(function () {
    return [{
      name: 'offset',
      options: {
        offset: typeof offset === 'number' ? [0, offset] : offset
      }
    }];
  }, [offset]);
  (0, _react.useEffect)(function () {
    // Only create popper instance once
    if (popperInstanceRef.current) {
      return undefined;
    }

    var triggerElement = triggerRef.current;
    var popperElement = popperRef.current; // Save the popper instance

    popperInstanceRef.current = (0, _core.createPopper)(triggerElement, popperElement, {
      placement: position,
      modifiers: defaultModifiers,
      strategy: strategy
    });
    var popperInstance = popperInstanceRef.current;

    var show = function show() {
      // Make the tooltip visible
      popperElement.setAttribute(showAttribute, '');
      /* Enable the event listeners for updating position
       ** setOptions for modifiers will overwrite others modifiers
       * so need to merge with the default modifiers
       */

      popperInstance.setOptions({
        modifiers: [].concat((0, _toConsumableArray2["default"])(defaultModifiers), [{
          name: 'eventListeners',
          enabled: true
        }])
      }); // Update its position

      popperInstance.update();
    };

    var hide = function hide() {
      // Hide the tooltip
      popperElement.removeAttribute(showAttribute); // Disable the event listeners for updating position when the tooltip is hidden

      popperInstance.setOptions({
        modifiers: [].concat((0, _toConsumableArray2["default"])(defaultModifiers), [{
          name: 'eventListeners',
          enabled: false
        }])
      });
    };

    bindEvents({
      triggerElement: triggerElement,
      show: show,
      hide: hide
    });
    return function () {
      removeEvents({
        triggerElement: triggerElement,
        show: show,
        hide: hide
      });
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [defaultModifiers, position, strategy, title, triggerRef]);
  var content = (0, _jsxRuntime.jsxs)(Popup, {
    ref: popperRef,
    className: className,
    maxWidth: maxWidth // Don't show tooltip if title doen't exist
    ,
    hidden: !title || disabled,
    delay: delay,
    children: [title, (0, _jsxRuntime.jsx)(Arrow, {
      "data-popper-arrow": true
    })]
  });
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [child, portal ? /*#__PURE__*/_reactDom["default"].createPortal(content, document.querySelector(portal)) : content]
  });
};

Tooltip.propTypes = {
  children: _propTypes.node,
  title: _propTypes.node,
  position: (0, _propTypes.oneOf)(positions),
  className: _propTypes.string,

  /**
   * CSS delay value
   */
  delay: _propTypes.string,

  /**
   * Tooltip inner's max width
   */
  maxWidth: _propTypes.number,
  offset: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.array]),

  /**
   * Tooltip's position style value
   */
  strategy: (0, _propTypes.oneOf)(['absolute', 'fixed']),
  disabled: _propTypes.bool,
  portal: _propTypes.string
};
Tooltip.defaultProps = {
  children: undefined,
  title: undefined,
  className: undefined,
  delay: '0.5s',
  position: 'top',
  maxWidth: 240,
  offset: 8,
  strategy: 'absolute',
  disabled: false,
  portal: undefined
};
var _default = Tooltip;
exports["default"] = _default;
//# sourceMappingURL=Tooltip.js.map